import axios from 'axios'
import globalState from '../shared/globalState'
import { API_URL } from './config'

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Получение CSRF токена
function getCSRFToken() {
  return document.cookie
    .split('; ')
    .find((row) => row.trim().startsWith('csrftoken='))
    ?.split('=')[1]
}

// Добавление CSRF токена к запросу
function attachCSRFToken(config) {
  if (
    ['post', 'put', 'patch', 'delete'].includes(config.method?.toLowerCase())
  ) {
    const csrfToken = getCSRFToken()
    if (csrfToken) {
      config.headers['X-CSRFToken'] = csrfToken
    } else {
      console.warn('CSRF token not found in cookies')
    }
  }
  return config
}

// Добавление JWT токена к запросу
function attachAuthToken(config) {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
}

async function refreshAccessToken() {
  try {
    const refreshToken = localStorage.getItem('refresh_token')

    if (!refreshToken) {
      throw new Error('Refresh token отсутствует')
    }

    // Отправляем запрос на обновление токена
    const response = await axios.post(
      `${API_URL}/API_FRONT/token/refresh/`,
      { refresh: refreshToken },
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )

    // Сохраняем новый access токен
    const newAccessToken = response.data.access
    localStorage.setItem('access_token', newAccessToken)

    console.log('Access token успешно обновлен')
    return newAccessToken
  } catch (error) {
    console.error('Ошибка при обновлении токена:', error)

    // Если обновление не удалось, очищаем токены и делаем редирект на логин
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    if (!window.location.pathname.includes('/login')) {
      window.location.href = '/login'
    }

    return null
  }
}

// Интерцептор запросов
api.interceptors.request.use((config) => {
  config = attachCSRFToken(config)
  config = attachAuthToken(config)
  return config
})

// Интерцептор ответов
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    // Проверяем, что это 401 ошибка и запрос еще не повторялся
    if (error.response?.status === 401 && !originalRequest._isRetry) {
      originalRequest._isRetry = true

      // Проверяем, что это не запрос на обновление токена
      if (!originalRequest.url.includes('/token/refresh/')) {
        try {
          const refreshToken = localStorage.getItem('refresh_token')

          // Если нет refresh токена - разлогиниваем
          if (!refreshToken) {
            throw new Error('No refresh token available')
          }

          // Пытаемся обновить токен
          const response = await axios.post(
            `${API_URL}/API_FRONT/token/refresh/`,
            { refresh: refreshToken },
            {
              withCredentials: true,
              headers: {
                'Content-Type': 'application/json',
              },
            },
          )

          // Сохраняем новый access токен
          const newAccessToken = response.data.access
          localStorage.setItem('access_token', newAccessToken)

          // Обновляем заголовок Authorization и повторяем запрос
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`
          return api(originalRequest)
        } catch (refreshError) {
          console.error('Token refresh failed:', refreshError)

          // Очищаем токены и редиректим на логин
          localStorage.removeItem('access_token')
          localStorage.removeItem('refresh_token')

          // Если это не страница логина - делаем редирект
          if (!window.location.pathname.includes('/login')) {
            window.location.href = '/login'
          }

          return Promise.reject(refreshError)
        }
      }
    }
    //
    //
    //
    //       globalState.setState('GlobalSnackbar',{severity : "warning" , text : "Сессия истекла!"})
    // Обработка 403 ошибки
    // Обработка 403 ошибки
    if (error.response?.status === 403) {
      console.error('403 Forbidden:', error.response.data)

      try {
        // Попытка обновить токен
        const newAccessToken = await refreshAccessToken()

        if (newAccessToken) {
          // Обновляем заголовок Authorization с новым токеном
          error.config.headers['Authorization'] = `Bearer ${newAccessToken}`

          // Повторяем оригинальный запрос
          return api.request(error.config)
        }
      } catch (refreshError) {
        console.error('Ошибка при обновлении токена:', refreshError)
      }

      // Перенаправление на страницу авторизации через 3 секунды
      if (!window.location.pathname.includes('/login')) {
        setTimeout(() => {
          window.location.href = '/login'
        }, 3000) // Задержка в миллисекундах
      }
    }

    // Для всех других ошибок просто пробрасываем их дальше
    return Promise.reject(error)
  },
)

// Инициализация CSRF
export async function ensureCSRF() {
  try {
    await api.get('/API_FRONT/csrf/')
  } catch (error) {
    console.error('Failed to set CSRF cookie:', error)
  }
}

ensureCSRF()
export default api
